// extracted by mini-css-extract-plugin
export default {"root":"vuPVWq","itemClickWrapper":"gYUS8y","imageZoomBtn":"QKORNG","sizer":"NmlYkT","imageWrapper":"bWBdW5","imageBorder":"F_KSrK","image":"uIPsPG","overlay":"XelgOX"};